export default __webpack_public_path__ + "static/media/login.28e3a09b.svg";